import React from 'react';
interface KpiCardProps {
  label: string;
  value: string;
  meta?: string;
  tone?: 'default' | 'warn' | 'risk';
}
const toneClasses: Record<string, string> = {
  default: 'text-foreground',
  warn: 'text-[#8a6f11]',
  risk: 'text-uae-red'
};
export function KpiCard({
  label,
  value,
  meta,
  tone = 'default'
}: KpiCardProps) {
  return <div className="rounded-sm border border-border bg-card px-4 py-3" data-id="element-395" data-mp="61o7va63iukf">
      <p className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-396" data-mp="k28t0czhh2h3">{label}</p>
      <p className={`mt-1.5 text-2xl font-semibold tabular tracking-tight ${toneClasses[tone]}`} data-id="element-397" data-mp="g28aoh99k74r">
        {value}
      </p>
      {meta && <p className="mt-1 text-[11px] text-muted-foreground" data-id="element-398" data-mp="tsbp4m1wiwjn">{meta}</p>}
    </div>;
}